// extracted by mini-css-extract-plugin
module.exports = {"attachment":"attachment_attachment__2ib4v"};